
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAssociatedTargetRadarIec as ObiAssociatedTargetRadarIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-associated-target-radar-iec.js';
 
 
 

 
 export const ObiAssociatedTargetRadarIec = createComponent({
   react: React,
   tagName: 'obi-associated-target-radar-iec',
   elementClass: ObiAssociatedTargetRadarIecElement,
   events: {
     
   }
  });
 
 